import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { getRelativeUrl } from './resolveUrl'
import { ICurrentRouteInfo, IRoutingConfig, RouteInfo } from './types'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'

const currentRouteInfo = (routingConfig: IRoutingConfig): ICurrentRouteInfo => {
	let routeInfo: RouteInfo
	let prevRouteInfo: RouteInfo | null = null

	return {
		getCurrentRouteInfo: () => {
			return routeInfo ? routeInfo : null
		},
		getPreviousRouterInfo: () => {
			return prevRouteInfo
		},
		updateCurrentRouteInfo: (nextRouteInfo: RouteInfo) => {
			prevRouteInfo = routeInfo
			routeInfo = nextRouteInfo
		},
		updateRouteInfoUrl: (parsedUrl: URL) => {
			if (routeInfo) {
				routeInfo.parsedUrl = parsedUrl
				routeInfo.relativeUrl = getRelativeUrl(parsedUrl.href, routingConfig.baseUrl)
			}
		},
	}
}

export const CurrentRouteInfo = withDependencies([named(SiteFeatureConfigSymbol, name)], currentRouteInfo)
